// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {successAlert, errorAlert} from '@alert'

// ** Axios Imports
import axios from 'axios'

export const getAllData = createAsyncThunk('sociallinks/getAllData', async () => {
  const response = await axios.get('/api/users/list/all-data')
  return response.data
})

export const getData = createAsyncThunk('sociallinks/getData', async params => {
  const response = await axios.get(process.env.REACT_APP_BASE_URL + '/api/dashboard/social-links', params)
  return {
    params,
    data: response.data.data,
    totalPages: response.data.total,
    loading: true
  }
})

export const getUser = createAsyncThunk('sociallinks/getUser', async id => {
  const response = await axios.get('/api/users/user', { id })
  return response.data.user
})

export const addUser = createAsyncThunk('sociallinks/addUser', async (user, { dispatch, getState }) => {
  await axios.post(process.env.REACT_APP_BASE_URL + '/api/dashboard/social-links', user).then(res => {
    successAlert()
  }).catch(err => {
    errorAlert()
  })
  await dispatch(getData(getState().sociallinks.params))
  // await dispatch(getAllData())
  return user
})

export const deleteUser = createAsyncThunk('sociallinks/deleteUser', async (id, { dispatch, getState }) => {
  await axios.delete(process.env.REACT_APP_BASE_URL + `/api/dashboard/social-links/${id}`).then(res => {
    successAlert()
  }).catch(err => {
    errorAlert()
  })
  await dispatch(getData(getState().sociallinks.params))
  // await dispatch(getAllData())
  return id
})
export const updateUser = createAsyncThunk('sociallinks/updateUser', async (params, { dispatch, getState }) => {
  await axios.post(process.env.REACT_APP_BASE_URL + `/api/dashboard/social-links/${params.id}`, params.user).then(res => {
    successAlert()
  }).catch(err => {
    errorAlert()
  })
  await dispatch(getData(getState().sociallinks.params))
  // await dispatch(getAllData())
  return params.user
})


export const sociallinksSlice = createSlice({
  name: 'sociallinks',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    loading: false
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload
        state.loading = action.payload.loading
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.loading = action.payload.loading
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
        state.loading = action.payload.loading
      })
  }
})

export default sociallinksSlice.reducer

/*export const uppdetUser = createAsyncThunk('sociallinks/getUser', async (id, { dispatch, getState }) => {
  const response = await axios.get(process.env.REACT_APP_BASE_URL + `/api/dashboard/social-links/${id}`)
  await dispatch(getData(getState().sociallinks.params))
  return id
})
* */